import { connect } from 'react-redux'

import GestionDrivers from '../../../pages/settings/Drivers'
import {
  resetSuccessAction,
  fetchParticipants,
  onSearch,
  pageChanged,
  pageLimitChanged,
  removeError,
  resetParticipantConfig,
  roleDriverFiltreChange,
} from '../../../redux/participants/actions'

import {
  getParticipants,
  getParticipantsCount,
  getParticipantsListIsLoading,
  getErrorMessage,
  getIsErrorFetch,
  getIsSuccessRefresh,
  getSuccess,
} from '../../../redux/participants/selectors'
import { getErrorMessageConfig } from '../../../redux/configuration/selectors'
import { removeErrorConfig } from '../../../redux/configuration/actions'

const mapStateToProps = (state) => ({
  isLoadingDriverList: getParticipantsListIsLoading(state),
  drivers: getParticipants(state),
  driverCount: getParticipantsCount(state),
  errorMessage: getErrorMessage(state),
  isErrorFetch: getIsErrorFetch(state),
  isSuccessRefresh: getIsSuccessRefresh(state),
  success: getSuccess(state),
  errorMessageConfig: getErrorMessageConfig(state),
})

const mapDisptachToProps = (dispatch) => ({
  fetchData: () => {
    dispatch(roleDriverFiltreChange())
    dispatch(fetchParticipants())
  },
  pageLimitChanged: (limit) => {
    dispatch(pageLimitChanged(limit))
    dispatch(fetchParticipants())
  },
  pageChanged: (offset) => {
    dispatch(pageChanged(offset))
    dispatch(fetchParticipants())
  },
  removeError: () => dispatch(removeError()),
  removeErrorConfig: () => dispatch(removeErrorConfig()),
  resetSuccessAction: () => dispatch(resetSuccessAction()),
  onCloseReset: () => dispatch(resetParticipantConfig()),

  searchData: (search) => {
    dispatch(onSearch(search))
    dispatch(fetchParticipants())
  },
})

export default connect(mapStateToProps, mapDisptachToProps)(GestionDrivers)
